<div class="settings-previous-wrapper">
  <div class="settings-card previous-card" [formGroup]="form">
    <wm-common-text class="section-title" [data]="{ text: 'Previous System Data' }"></wm-common-text>

    <div class="previous-content">
      <label class="replace-row">
        <input
          type="checkbox"
          class="replace-checkbox"
          formControlName="clearExisting"
          [(ngModel)]="uploadRequest.clearExisting"
          (ngModelChange)="onClearExistingChange($event)"
        />
        <wm-common-text [data]="{ text: 'Replace any existing data' }"></wm-common-text>
      </label>

      <div *ngIf="uploadRequest.clearExisting">
        <wm-common-text
          class="warning-text"
          [data]="{
            text:
              'WARNING: any Previous System Data previously imported for this jurisdiction will be permanently deleted, including all attachments.',
            color: 'danger'
          }"
        ></wm-common-text>
      </div>

      <!-- Toggles row -->
      <div class="toggles-row">
        <!-- Upload Data -->
        <div class="toggle-block">
          <label class="toggle-item">
            <input
              type="checkbox"
              class="native-toggle"
              formControlName="uploadData"
              [(ngModel)]="uploadData"
              (ngModelChange)="onUploadDataChange($event)"
            />
            <wm-common-text class="toggle-label" [data]="{ text: 'Upload Data' }"></wm-common-text>
          </label>

          <!-- Upload Data Options -->
          <div *ngIf="uploadData" class="toggle-options">
            <div class="file-row">
              <button type="button" class="btn-select-file" (click)="dataFileInput.click()">SELECT FILE</button>
              <input
                #dataFileInput
                type="file"
                accept="*/*"
                (change)="onDataFileSelected($event)"
                hidden
              />

              <div *ngIf="dataFileName" class="file-info">
                <button class="file-name-btn" type="button" (click)="viewSelectedFile('data')" title="View file">
                  <span class="file-name-text">{{ dataFileName }}</span>
                </button>

                <div class="file-actions">
                  <button type="button" class="btn-delete-file" (click)="requestDeleteFile('data')">DELETE</button>
                </div>
              </div>
            </div>

            <div class="help-text">
              <wm-common-text
                class="warning-text"
                [data]="{
                  text:
                    'This CSV file must contain six columns (the searchable fields): permit_number, parcel_number, applicant, address, issue_date, type. All other columns not given those names will be included as expandable details for that record.'
                }"
              ></wm-common-text>
            </div>

            <div *ngIf="uploadData && !dataFileName" class="text-danger validation-note">
              <wm-common-text [data]="{ text: 'Please select a CSV file' }"></wm-common-text>
            </div>
          </div>
        </div>

        <!-- Upload Data Attachments -->
        <div class="toggle-block">
          <label class="toggle-item">
            <input
              type="checkbox"
              class="native-toggle"
              formControlName="uploadDataAttachments"
              [(ngModel)]="uploadDataAttachments"
              (ngModelChange)="onUploadDataAttachmentsChange($event)"
            />
            <wm-common-text class="toggle-label" [data]="{ text: 'Upload Data Attachments' }"></wm-common-text>
          </label>

          <div *ngIf="uploadDataAttachments" class="toggle-options attachments-options">
            <div class="attachment-warning">
              <wm-common-text
                class="warning-text"
                [data]="{
                  text:
                    'Attachments must be located in a dedicated folder on \\\\tsc.schneidercorp.com\\gisdata\\GeoPermits\\previous-system-imports. Create a CSV index file with two columns: permit_number and path. The permit number must match a Previous System Data record exactly and the path should specify the location starting with the dedicated folder.'
                }"
              ></wm-common-text>
            </div>

            <div class="file-row">
              <button type="button" class="btn-select-file" (click)="indexFileInput.click()">SELECT INDEX FILE</button>
              <input
                #indexFileInput
                type="file"
                accept="*/*"
                (change)="onIndexFileSelected($event)"
                hidden
              />

              <div *ngIf="indexFileName" class="file-info">
                <button class="file-name-btn" type="button" (click)="viewSelectedFile('index')" title="View index file">
                  <span class="file-name-text">{{ indexFileName }}</span>
                </button>

                <div class="file-actions">
                  <button type="button" class="btn-delete-file" (click)="requestDeleteFile('index')">DELETE</button>
                </div>
              </div>
            </div>

            <div *ngIf="uploadDataAttachments && !indexFileName" class="text-danger validation-note">
              <wm-common-text [data]="{ text: 'Please select a CSV index file' }"></wm-common-text>
            </div>
          </div>
        </div>
      </div>

      <!-- Save row -->
      <div class="save-row">
        <button
          class="btn-disabled save-btn"
          [class.btn-primary]="isFormValidForUpload() && !isUploading"
          [class.btn-disabled]="!isFormValidForUpload() || isUploading"
          [disabled]="!isFormValidForUpload() || isUploading"
          (click)="checkUpload()"
        >
        SAVE
        </button>
      </div>
    </div>
  </div>

  <!-- confirmation modal -->
  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="onConfirmModalYes()"
    (onNoClick)="onConfirmModalNo()"
    [isApplicantMobileview]="true"
  ></wm-common-confirmation-modal>
</div>
